import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_option_group = _resolveComponent("q-option-group")!

  return (_openBlock(), _createBlock(_component_q_option_group, {
    dense: "",
    modelValue: _ctx.theModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel) = $event)),
    options: _ctx.booleanParameterOptions,
    size: "xs",
    color: "primary",
    type: "radio",
    inline: "",
    disable: !_ctx.editable
  }, null, 8, ["modelValue", "options", "disable"]))
}